var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _rect, _rect2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 158,
    viewBox: "0 0 211 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.683,
    cy: 79,
    r: 78.0488,
    fill: "#EEF7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7321,
    cy: 20.4631,
    r: 7.80488,
    fill: "#EEF7FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.536,
    cy: 123.878,
    r: 5.85366,
    fill: "#EEF7FE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7561,
    cy: 135.585,
    r: 9.7561,
    fill: "#EEF7FE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.244,
    cy: 45.8293,
    r: 9.7561,
    fill: "#EEF7FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.707,
    cy: 11.6828,
    r: 6.82927,
    fill: "#EEF7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17749_701744)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.083 16.5605C90.7546 16.5605 76.311 24.6289 67.5214 36.9961C64.6511 36.3192 61.6577 35.961 58.5807 35.961C37.1513 35.961 19.7793 53.333 19.7793 74.7624C19.7793 96.1918 37.1513 113.564 58.5807 113.564H58.5808V113.564H155.584V113.564C174.335 113.564 189.535 98.3631 189.535 79.6125C189.535 60.8618 174.335 45.6613 155.584 45.6613C154.252 45.6613 152.938 45.738 151.646 45.8872C144.214 28.6369 127.059 16.5605 107.083 16.5605Z",
    fill: "#EEF7FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5807,
    cy: 74.7623,
    r: 38.8014,
    fill: "url(#paint0_linear_17749_701744)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.083,
    cy: 65.0623,
    r: 48.5017,
    fill: "url(#paint1_linear_17749_701744)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.584,
    cy: 79.6124,
    r: 33.9512,
    fill: "url(#paint2_linear_17749_701744)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_17749_701744)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.3657,
    y: 82.9023,
    width: 54.6341,
    height: 54.6341,
    rx: 27.3171,
    fill: "#2C74D6",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17749_701744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 98,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8687,
    y: 98.29,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17749_701744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8687 117.29V115.29H97.8687V108.29C97.8687 106.907 98.2853 105.678 99.1187 104.603C99.952 103.528 101.035 102.823 102.369 102.49V101.79C102.369 101.373 102.514 101.019 102.806 100.728C103.098 100.436 103.452 100.29 103.869 100.29C104.285 100.29 104.639 100.436 104.931 100.728C105.223 101.019 105.369 101.373 105.369 101.79V102.49C106.702 102.823 107.785 103.528 108.619 104.603C109.452 105.678 109.869 106.907 109.869 108.29V115.29H111.869V117.29H95.8687ZM103.869 120.29C103.319 120.29 102.848 120.094 102.456 119.703C102.064 119.311 101.869 118.84 101.869 118.29H105.869C105.869 118.84 105.673 119.311 105.281 119.703C104.889 120.094 104.419 120.29 103.869 120.29ZM99.8687 115.29H107.869V108.29C107.869 107.19 107.477 106.248 106.694 105.465C105.91 104.682 104.969 104.29 103.869 104.29C102.769 104.29 101.827 104.682 101.044 105.465C100.26 106.248 99.8687 107.19 99.8687 108.29V115.29Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17749_701744",
    x: 0.267105,
    y: 16.5605,
    width: 208.781,
    height: 136.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.90244,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_17749_701744"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.80488
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.90244
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17749_701744"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.90244,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_17749_701744"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.5122
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7073
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17749_701744",
    result: "effect2_dropShadow_17749_701744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17749_701744",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_17749_701744",
    x: 68.5608,
    y: 75.0975,
    width: 70.244,
    height: 70.2435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.90244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17749_701744"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_17749_701744",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17749_701744",
    x1: 28.7868,
    y1: 49.1257,
    x2: 97.3821,
    y2: 113.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17749_701744",
    x1: 69.8404,
    y1: 33.0165,
    x2: 155.585,
    y2: 113.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17749_701744",
    x1: 129.514,
    y1: 57.1803,
    x2: 189.535,
    y2: 113.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C74D6",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default "data:image/svg+xml,%3csvg width='211' height='158' viewBox='0 0 211 158' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='103.683' cy='79' r='78.0488' fill='%23EEF7FE'/%3e %3ccircle cx='21.7321' cy='20.4631' r='7.80488' fill='%23EEF7FE'/%3e %3ccircle cx='189.536' cy='123.878' r='5.85366' fill='%23EEF7FE'/%3e %3ccircle cx='20.7561' cy='135.585' r='9.7561' fill='%23EEF7FE'/%3e %3ccircle cx='201.244' cy='45.8293' r='9.7561' fill='%23EEF7FE'/%3e %3ccircle cx='182.707' cy='11.6828' r='6.82927' fill='%23EEF7FE'/%3e %3cg filter='url(%23filter0_dd_17749_701744)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M107.083 16.5605C90.7546 16.5605 76.311 24.6289 67.5214 36.9961C64.6511 36.3192 61.6577 35.961 58.5807 35.961C37.1513 35.961 19.7793 53.333 19.7793 74.7624C19.7793 96.1918 37.1513 113.564 58.5807 113.564H58.5808V113.564H155.584V113.564C174.335 113.564 189.535 98.3631 189.535 79.6125C189.535 60.8618 174.335 45.6613 155.584 45.6613C154.252 45.6613 152.938 45.738 151.646 45.8872C144.214 28.6369 127.059 16.5605 107.083 16.5605Z' fill='%23EEF7FE'/%3e %3ccircle cx='58.5807' cy='74.7623' r='38.8014' fill='url(%23paint0_linear_17749_701744)'/%3e %3ccircle cx='107.083' cy='65.0623' r='48.5017' fill='url(%23paint1_linear_17749_701744)'/%3e %3ccircle cx='155.584' cy='79.6124' r='33.9512' fill='url(%23paint2_linear_17749_701744)'/%3e %3c/g%3e %3cg filter='url(%23filter1_b_17749_701744)'%3e %3crect x='76.3657' y='82.9023' width='54.6341' height='54.6341' rx='27.3171' fill='%232C74D6' fill-opacity='0.4'/%3e %3cmask id='mask0_17749_701744' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='91' y='98' width='25' height='25'%3e %3crect x='91.8687' y='98.29' width='24' height='24' fill='%23D9D9D9'/%3e %3c/mask%3e %3cg mask='url(%23mask0_17749_701744)'%3e %3cpath d='M95.8687 117.29V115.29H97.8687V108.29C97.8687 106.907 98.2853 105.678 99.1187 104.603C99.952 103.528 101.035 102.823 102.369 102.49V101.79C102.369 101.373 102.514 101.019 102.806 100.728C103.098 100.436 103.452 100.29 103.869 100.29C104.285 100.29 104.639 100.436 104.931 100.728C105.223 101.019 105.369 101.373 105.369 101.79V102.49C106.702 102.823 107.785 103.528 108.619 104.603C109.452 105.678 109.869 106.907 109.869 108.29V115.29H111.869V117.29H95.8687ZM103.869 120.29C103.319 120.29 102.848 120.094 102.456 119.703C102.064 119.311 101.869 118.84 101.869 118.29H105.869C105.869 118.84 105.673 119.311 105.281 119.703C104.889 120.094 104.419 120.29 103.869 120.29ZM99.8687 115.29H107.869V108.29C107.869 107.19 107.477 106.248 106.694 105.465C105.91 104.682 104.969 104.29 103.869 104.29C102.769 104.29 101.827 104.682 101.044 105.465C100.26 106.248 99.8687 107.19 99.8687 108.29V115.29Z' fill='white'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_dd_17749_701744' x='0.267105' y='16.5605' width='208.781' height='136.028' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='3.90244' operator='erode' in='SourceAlpha' result='effect1_dropShadow_17749_701744'/%3e %3cfeOffset dy='7.80488'/%3e %3cfeGaussianBlur stdDeviation='3.90244'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_17749_701744'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeMorphology radius='3.90244' operator='erode' in='SourceAlpha' result='effect2_dropShadow_17749_701744'/%3e %3cfeOffset dy='19.5122'/%3e %3cfeGaussianBlur stdDeviation='11.7073'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow_17749_701744' result='effect2_dropShadow_17749_701744'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_17749_701744' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_b_17749_701744' x='68.5608' y='75.0975' width='70.244' height='70.2435' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeGaussianBlur in='BackgroundImageFix' stdDeviation='3.90244'/%3e %3cfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_17749_701744'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_17749_701744' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_17749_701744' x1='28.7868' y1='49.1257' x2='97.3821' y2='113.564' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_17749_701744' x1='69.8404' y1='33.0165' x2='155.585' y2='113.564' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_17749_701744' x1='129.514' y1='57.1803' x2='189.535' y2='113.564' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%232C74D6' stop-opacity='0.4'/%3e %3cstop offset='0.350715' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };